import { useContext, useEffect, useMemo, useState } from "react"
import { Checkbox } from 'primereact/checkbox';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import _ from "underscore";
import { useCommanKit } from "./useCommanKit";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { ToastContext } from "../../../context/ToastContext";
import { dateConvert } from "../../../utils/Helper";

export const useDocumentList = ({ data, onNext, readOnly }) => {
    const { showSuccess, showError } = useContext(ToastContext);
    const { getEmployeeDetails } = useCommanKit({ data })
    const [documents, setDocuments] = useState([]);
    const [loader, setloader] = useState(true);
    const [isChanged, setIsChanged] = useState(false);
    const [submitStatusId, setSubmitStatusId] = useState(0)

    useEffect(() => {
        const group = _.find(data?.attributeGroup, { attribute_group_key: "employee_checklist_document" });
        if (group) {
            const options = _.filter(data?.attributeItems, { attribute_group_id: group.attribute_group_id })
                .map(item => ({
                    document_name: item.item_name,
                    document_item_id: item.attribute_item_id,
                    reason_for_not_submit: "",
                    expected_submit_date: "",
                    is_submitted: false,
                    submitted_date: ""
                }));
            data?.employee?.user_code && getEmployeeDetails("employee_document_checklist", data?.employee?.user_code).then((res) => {
                setSubmitStatusId(res?.employee_document_checklist?.[0]?.submit_status_id || 0)
                const combined = options.map(item => {
                    const resp = res?.employee_document_checklist?.find(r => r.document_item_id === item.document_item_id);
                    return resp ? resp : item;
                });
                setDocuments(combined);
                setloader(false)
            }).catch((error) => {
                setloader(false)
            })
        }
    }, [data?.attributeGroup, data?.attributeItems]);

    const srNoBodyTemplate = (rowData, options) => options.rowIndex + 1;

    const submittedBodyTemplate = (rowData) => (
        <Checkbox
            checked={rowData.is_submitted}
            onChange={(e) => handleDocumentChange(rowData, { is_submitted: e.checked })}
        />
    );

    const reasonBodyTemplate = (rowData) => (
        <>
            {readOnly ? <div className="d-flex justify-content-center">{rowData.reason_for_not_submit}</div> : <InputText
                value={rowData.reason_for_not_submit}
                onChange={(e) => handleDocumentChange(rowData, { reason_for_not_submit: e.target.value })}
                className="input-text w100"
                onBlur={(e) => handleDocumentChange(rowData, { reason_for_not_submit: e.target.value })}
            />}
        </>
    );

    const dateBodyTemplate = (rowData) => (
        <div className="inspectra-calendar">
            {readOnly ? <div className="d-flex justify-content-center">{rowData.expected_submit_date ? dateConvert(rowData.expected_submit_date) : ''}</div> : <Calendar
                value={rowData.expected_submit_date ? new Date(rowData.expected_submit_date) : null}
                onChange={(e) => handleDocumentChange(rowData, { expected_submit_date: e.target.value })}
                className="input-dd"
                dateFormat="dd-mm-yy"
                minDate={new Date()}
            />}

        </div>
    );

    const handleDocumentChange = (rowData, changes) => {
        setIsChanged(true)
        setDocuments(prevData => prevData.map(doc =>
            doc.document_item_id === rowData.document_item_id ? { ...doc, ...changes } : doc)
        );
    };

    const handleSubmit = async (rowData, changes) => {
        if (!isChanged) {
            onNext();
            return
        }
        const updatedDocuments = documents.map(doc =>
            doc.document_item_id === rowData.document_item_id ? { ...doc, ...changes } : doc
        );

        const formatDate = (date) => {
            if (!date) return "";
            return (date instanceof Date) ? date.toISOString() : date;
        };

        const payload = {
            tvp_document_checklist: updatedDocuments.map(doc => ({
                document_item_id: doc.document_item_id,
                is_submitted: doc.is_submitted || false,
                submitted_date: doc.submitted_date,
                reason_for_not_submit: doc.reason_for_not_submit || '',
                expected_submit_date: formatDate(doc.expected_submit_date),
            })),
            "submit_status_id": submitStatusId || 0,
            "is_save": true
        };
        try {
            const res = await services.getInvokeRemote("POST", Urls("UPSERTEMPLOYEEDOCCHECKLISTDATA"), payload);
            if (!res?.body?.error_status) {
                showSuccess('Sucess', res.body.message)
                onNext()
            } else {
                showError("Error", res.body.errorMessage);
            }
        } catch (error) {
            console.error("Upsert error", error);
        }
    };



    return useMemo(() => ({
        documents, dateBodyTemplate, reasonBodyTemplate, submittedBodyTemplate, srNoBodyTemplate, loader, handleSubmit
    }), [documents, dateBodyTemplate, reasonBodyTemplate, submittedBodyTemplate, srNoBodyTemplate, loader, handleSubmit])
}